<template>
  <div class="box">
    <h3>验证码已发送至手机：</h3>
    <h4>{{phone}}</h4>
    <van-form class="form">
      <p style="margin-bottom:.21rem;">短信验证码</p>
      <div class="flexBox" style="margin-bottom: 0.64rem;">
        <van-field
          v-model="verifyCode"
          placeholder="请输入短信验证码"
          class="input"
          style="width:5.6rem;"
        ></van-field>

        <XrkSlideVerify
          ref="verification"
          :options="verificationOptions"
          @success="checkSuccessful"
          @close="verifyClose"
        >
          <van-button
            class="smsBtn"
            :class="[sendText==='重新获取'?'resendBtn':'countBtn']"
            @click="send"
            :disabled="sendLock || sendText !== '重新获取'"
          >{{ sendText }}</van-button>
        </XrkSlideVerify>
      </div>
      <van-button
        type="primary"
        class="confirmBtn"
        style="marginTop:1rem;"
        @click="goHome"
        :disabled="!verifyCode"
      >完成验证</van-button>
    </van-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { customerUser, getVerification } from '@/api/ajax';
import { jumpBeforeRegisterUrl } from '@/utils/storage';
import { syncUserInfo } from '@/utils/storage';

export default {
  data() {
    return {
      verifyCode: '',
      sendText: '重新获取',
      timer: null,
      resendFlag: false,
      time: new Date().getTime(),
      imgVerifyCode2: '',
      sendLock: false,
      timer: null,
      sendText: '获取验证码',
      verificationOptions: {
        // 接口请求 防抖
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          initImages: getVerification,
          checkVerification: position => {
            return customerUser.sendMessageCode({
              phone: this.phone,
              ...position
            });
          }
        },
        errorAnimationDuration: 800
      }
    };
  },
  methods: {
    ...mapActions(['savePhone']),
    changePic() {
      this.time = new Date().getTime();
    },
    async goHome() {
      const {
        data: { data }
      } = await customerUser.verifyLogin({
        phone: this.phone,
        verifyCode: this.verifyCode
      });
      let { token, user, channel, tJhEnterpriseChannelWhiteList } = data;
      user.token = token;
      await syncUserInfo(user);
      this.$sa.login(user.id);
      if (channel.userPerfectType === 1 && !user.fullName) {
        this.$router.push({
          name: 'perfect'
        });
      } else if (channel.visitRestrictType === 3) {
        this.$router.push({
          name: 'word'
        });
      } else if (
        channel.visitRestrictType === 4 &&
        !tJhEnterpriseChannelWhiteList
      ) {
        //不在白名单里面
        this.$router.push({
          name: 'word'
        });
      } else {
        let jumpUrl = jumpBeforeRegisterUrl();
        if (!jumpUrl) {
          this.$router.push({
            name: 'home'
          });
        }
      }
    },
    send() {
      if (this.sendText === '重新获取') {
        this.resendFlag = true;
        this.sendLock = true;
        this.sendText = 60;
        this.$refs['verification'].visible = true;
      }
    },
    countDown() {
      this.timer && clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.sendText !== '重新获取' && this.sendText > 0) {
          this.sendText--;
        } else {
          this.sendText = '重新获取';
          this.sendLock = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    verifyClose() {
      clearInterval(this.timer);
      this.sendText = '获取验证码';
      this.sendLock = false;
    },
    checkSuccessful() {
      this.countDown();
    }
  },
  computed: {
    ...mapState({
      phone: state => state.register.phone,
      imgVerifyCode: state => state.register.imgVerifyCode
    }),
    imgUrl() {
      return `${customerUser.verifyImgCode}?phone=${this.phone}&v=${this.time}`;
    }
  },
  created() {
    this.sendText = 60;
    this.countDown();
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer);
  }
};
</script>
<style lang='less' scoped>
@import '~@/style/theme.less';
.box {
  padding: 1.6rem 0.53rem;
  h4 {
    margin-top: 0.43rem;
    margin-bottom: 1.6rem;
  }
  .smsBtn {
    width: 2.56rem;
    height: 1.17rem;
    border-radius: 0.21rem;
    border: 0.04rem solid @primary-color;
    margin-left: 0.53rem;
  }
  .countBtn {
    background: rgba(255, 255, 255, 1);
    span {
      color: @primary-color;
      font-weight: bold;
    }
  }
  .resendBtn {
    background: @primary-color;
    span {
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>